import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { listPhysicalAssets } from 'api/PhysicalAssets';

export const usePhysicalAssetsList = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(
    ['physical-assets-list', ...dependencies],
    () => listPhysicalAssets(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...options
    }
  );
};
